import { render, staticRenderFns } from "./ProjectPOA.vue?vue&type=template&id=5f7615aa"
import script from "./ProjectPOA.vue?vue&type=script&lang=js"
export * from "./ProjectPOA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports